import React         from 'react';
import Utils         from 'utils';
// -------------------------------------------------------

class ContentsModal extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
    
    // クローズ処理
    document.getElementById('contents').addEventListener('click', function(e){
      if( this.state.view == false ) return false;
      
      try {
        let cs = e.target.getAttribute('class');
        if( cs == undefined || cs == null ) cs = '';
        
        if( Utils.getParentClass(e.target, 'message-box') == null && Utils.getParentClass(e.target, 'contents-modal-slide') == null && cs != 'sub-loading' && cs.indexOf('message-mode-button') == -1 ){
          if( this.props.auto_close !== undefined && this.props.auto_close !== false ){
            if( this.state.miniaturization == false ) this.setState({ miniaturization: true });
          }
        }
      } catch(e) {console.log(e);}
    }.bind(this));
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      miniaturization : false,
      animation : 'close',
      set_cache : '',
      is_background : false,
    }
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  componentDidMount() {
    setTimeout( function(){
      this.setState({ animation: 'open' });
    }.bind(this), 10);
  }
  // -------------------------------------------------------
  
  closeEvent(props) {
    this.setState({ animation: 'close' });
    
    setTimeout( function(){
      this.props.close_ev.bind(this)(false);
    }.bind(this), 250);
  }
  // -------------------------------------------------------
  
  UNSAFE_componentWillReceiveProps(nextProps) {
    if( this.props.reload == true ){
      if( nextProps.cache != this.state.set_cache ){
        this.setState({ set_cache: nextProps.cache, miniaturization: false });
      } else {
        this.setState({ miniaturization: (this.state.miniaturization == true) ? false : true });
      }
    }
  }
  // -------------------------------------------------------
  
  setIsBackground(flg) {
    this.setState({ is_background: flg });
  }
  // -------------------------------------------------------
  
  /*
   * 縮小化処理
   */
  setMiniaturization() {
    if( this.props.sub_event != undefined && this.props.sub_event != null ){
      this.props.sub_event.bind(this)();
    } else {
      this.setState({ miniaturization: (this.state.miniaturization == true) ? false : true });
    }
  }
  // -------------------------------------------------------
  
  render() {
    if( this.props.view == false ) return null;
    
    let miniaturization = (this.state.miniaturization == true) ? 'miniaturization' : '';
    
    let design = this.props.design;
    if( design == undefined ) design = '';
    
    // サブローディング処理;
    return (
      <div className={'contents-modal-slide '+ miniaturization +' '+ design}>
        { (this.state.is_background == true) && <div className="contents-modal-bg" /> }
        <div className={'contents-modal-box-slide '+ this.state.animation} onMouseOver={this.setIsBackground.bind(this, true)} onMouseOut={this.setIsBackground.bind(this, false)}>
          <div className="miniaturization-toggle" onClick={this.setMiniaturization.bind(this)}>
            { (this.state.miniaturization == true)
              ? <i className="material-icons">chevron_left</i>
              : <i className="material-icons">chevron_right</i>
            }
          </div>
          <div className="modal-main-contents">
            {this.props.html}
          </div>
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ContentsModal;